export const useXsrfToken = () => {
    const getCookie = (name: string) => {
        const value = `; ${document.cookie}`
        const parts = value.split(`; ${name}=`)
        if (parts.length === 2) return decodeURIComponent(parts.pop()!.split(';').shift()!)
    }

    return getCookie('XSRF-TOKEN')
}
